import React from 'react';
import { useLanguage } from 'Core/Translations/LanguageContext';
import FourByFour from '../../../../../../Assets/images/SudokuOriginsImages/4by4.png';
import SixBySix from '../../../../../../Assets/images/SudokuOriginsImages/6by6.png';
import NineByNine from '../../../../../../Assets/images/SudokuOriginsImages/9by9.png';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuOriginsStyles/SudokuOrigins.css';

export const SudokuOrigins = () => {
    const { t } = useLanguage();

    return (
        <div className="origins-content">
            <div className="grid-container">
                <ul className="grid-list">
                    <li className="grid-item">
                        <img
                            src={FourByFour}
                            alt="4X4 Sudoku example"
                            className="grid-image"
                            style={{ width: '100px' }}
                        />
                        <span className="size-label">{t.beginnersGuide.origins.gridSize.four}</span>
                    </li>
                    <li className="grid-item">
                        <img
                            src={SixBySix}
                            alt="6X6 Sudoku example"
                            className="grid-image"
                            style={{ width: '135px' }}
                        />
                        <span className="size-label">{t.beginnersGuide.origins.gridSize.six}</span>
                    </li>
                    <li className="grid-item">
                        <img
                            src={NineByNine}
                            alt="9X9 Sudoku example"
                            className="grid-image"
                            style={{ width: '180px' }}
                        />
                        <span className="size-label">{t.beginnersGuide.origins.gridSize.nine}</span>
                    </li>
                </ul>
            </div>

            <ul className="bullet-list">
                <li>{t.beginnersGuide.origins.bulletOne}</li>
                <li>{t.beginnersGuide.origins.bulletTwo}</li>
                <li>{t.beginnersGuide.origins.bulletThree}</li>
                <li>{t.beginnersGuide.origins.bulletFour}</li>
            </ul>
        </div>
    );
};

export default SudokuOrigins;